import { render, staticRenderFns } from "./ConfirmFederalProject.vue?vue&type=template&id=bdeb45b6&scoped=true"
import script from "./ConfirmFederalProject.vue?vue&type=script&lang=js"
export * from "./ConfirmFederalProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb45b6",
  null
  
)

export default component.exports